import {useEffect, useRef, useState} from "react";
import date from "../../../components/WebEditor/formPlugins/date";
import {Trans} from "@lingui/react/macro"

export default function DateCounter({ datetime,title }){

    const interval=useRef(null)

    const [state, setState] = useState({
        inited:false,
        seconds: 0,
        hours: 0,
        minutes: 0,
        days: 0,
    });

    const endDate=new Date(datetime)

    const calculTimeRemaining=() => {
        const currentTime = new Date();

        const timeRemaining = endDate.getTime() - currentTime.getTime();

        let seconds = Math.floor(timeRemaining / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        seconds %= 60;
        minutes %= 60;
        hours %= 24;

        // Setting States
        setState((prevState) => ({
            ...prevState,
            inited:true,
            seconds,
            minutes,
            hours,
            days,
        }));
    }

    useEffect(() => {
        calculTimeRemaining()
        interval.current=setInterval(calculTimeRemaining, 1000);

        return ()=>{
            clearInterval(interval.current)
        }
    }, []);

    if(!state.inited){
        return null
    }

    return (
        <Countdown countdownData={state} title={title} />
    );
};

const Countdown = ({ countdownData, title }) => {
    return (
        <div>
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",marginTop:"3rem",marginBottom:"3rem"}}>
                <h3 className={"countdown-title"}>{title}</h3>
                <div className='countdown-wrapper'>
                    <div className={countdownData.days>0?'countdown-box':'countdown-box-alert'}>
                        {countdownData.days}
                        <span className='countdown-legend'><Trans>Jours</Trans></span>
                    </div>
                    <div className={'countdown-box'}>
                        {countdownData.hours}
                        <span className='countdown-legend'><Trans>Heures</Trans></span>
                    </div>
                    <div className={'countdown-box'}>
                        {countdownData.minutes}
                        <span className='countdown-legend'><Trans>Minutes</Trans></span>
                    </div>
                    <div className={'countdown-box'}>
                        {countdownData.seconds}
                        <span className='countdown-legend'><Trans>Secondes</Trans></span>
                    </div>
                </div>
            </div>
        </div>
    );
};
